iScreenWizard.controller('TestinformatieController', function ($scope, $state, $mdDialog, Ajax, Dictionary, Rapporttemplate, Test, userService) {


    $scope.tests = [];
    $scope.user = userService.model;

    $scope.rapporttemplates = [];

    $scope.testotheken = [];


    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        Rapporttemplate.all({alleen_met_competentieprofiel_type: 1}).then(function (rapporttemplates) {
            angular.forEach(rapporttemplates, function (rapporttemplate) {
                if (rapporttemplate.informatiebestand_url.length > 0) {
                    rapporttemplate.informatiebestand_url = baseUrl + rapporttemplate.informatiebestand_url + '?jwt=' + userService.getToken();
                }
                if (rapporttemplate.voorbeeldbestand_url.length > 0) {
                    rapporttemplate.voorbeeldbestand_url = baseUrl + rapporttemplate.voorbeeldbestand_url + '?jwt=' + userService.getToken();
                }
            });
            $scope.rapporttemplates = rapporttemplates;
        });
        Test.all({voor_testotheek: 1}).then(function (testotheken) {
            angular.forEach(testotheken, function (testotheek) {
                if (testotheek.informatiebestand_url.length > 0) {
                    testotheek.informatiebestand_url = baseUrl + testotheek.informatiebestand_url + '?jwt=' + userService.getToken();
                }
                if (testotheek.voorbeeldbestand_url.length > 0) {
                    testotheek.voorbeeldbestand_url = baseUrl + testotheek.voorbeeldbestand_url + '?jwt=' + userService.getToken();
                }
            });
            $scope.testotheken = testotheken;
        });
    };

});